import { initials } from "@/lib/blessed";
import { cn } from "@/lib/utils";

export const CircleAvatar = ({ src, name, size = 48, ring, className, glow }) => {
  const style = { width: size, height: size, fontSize: size * 0.36 };
  return (
    <div
      className={cn("relative shrink-0 rounded-pill", className)}
      style={{
        padding: ring ? 3 : 0,
        background: ring || "transparent",
        boxShadow: glow ? `0 0 0 4px ${glow}33, 0 6px 20px ${glow}55` : undefined,
      }}
    >
      {src ? (
        <img
          src={src}
          alt={name || "avatar"}
          style={style}
          className="rounded-pill object-cover bg-surface-3"
          referrerPolicy="no-referrer"
        />
      ) : (
        <div
          style={style}
          className="rounded-pill grid place-items-center font-extrabold text-white"
        >
          <span
            className="w-full h-full rounded-pill grid place-items-center"
            style={{ background: "linear-gradient(135deg,#1E40AF,#5B21B6)" }}
          >
            {initials(name)}
          </span>
        </div>
      )}
    </div>
  );
};
